import React from "react";
import BlogCard from "./BlogCard";
import Img1 from "../../assets/places/jasiiro.jpg";
import Img2 from "../../assets/places/liidosomalia.jpg";
import Img3 from "../../assets/places/bari.jpg";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import {
  SuggestionCard,
  SuggestionCardForBestPlaces,
} from "../Travel/Suggestions";
import singapore from "../../assets/places/singapur/singapur4.jpg";
import backgroundImage1 from "../../assets/places/temple.jpg";
import backgroundImage2 from "../../assets/places/sight.jpg";
import backgroundImage3 from "../../assets/places/dubai.jpg";
import dubai from "../../assets/places/dubai/dubai.jpg";
import dubai1 from "../../assets/places/dubai/dubai1.jpg";
import dubai2 from "../../assets/places/dubai/dubai2.jpg";
import dubai3 from "../../assets/places/dubai/dubai3.jpg";
import dubai6 from "../../assets/places/dubai/dubai6.jpg";
import dubai7 from "../../assets/places/dubai/dubai7.jpg";
import dubai8 from "../../assets/places/dubai/dubai8.jpg";
import dubai9 from "../../assets/places/dubai/dubai9.jpg";
import dubai10 from "../../assets/places/dubai/dubai10.jpg";
import dubai5 from "../../assets/places/dubai/dubai5.jpg";
import dubai4 from "../../assets/places/dubai/dubai4.jpg";
import dubai12 from "../../assets/places/dubai/dubai12.jpg";
import malaysia from "../../assets/places/malaysia/malaysia.jpg";
import malaysia1 from "../../assets/places/malaysia/malaysia1.jpg";
import malaysia2 from "../../assets/places/malaysia/malaysia2.jpg";
import malaysia3 from "../../assets/places/malaysia/malaysia3.jpg";
import malaysia4 from "../../assets/places/malaysia/malaysia4.jpg";
import malaysia5 from "../../assets/places/malaysia/malaysia5.jpg";
import malaysia6 from "../../assets/places/malaysia/malaysia6.jpg";
import malaysiaBackground from "../../assets/places/malaysia/malaysia4.jpg";
import bali from "../../assets/places/bali/bali.jpg";
import bali1 from "../../assets/places/bali/bali1.jpg";
import bali2 from "../../assets/places/bali/bali2.jpg";
import singapur from "../../assets/places/singapur/singapur.jpg";
import singapur1 from "../../assets/places/singapur/singapur1.jpg";
import singapur2 from "../../assets/places/singapur/singapur2.jpg";
import singapur3 from "../../assets/places/singapur/singapur3.jpg";
import singapur4 from "../../assets/places/singapur/singapur4.jpg";
import singapur5 from "../../assets/places/singapur/singapur5.jpg";
import japan from "../../assets/places/japan/japan.jpg";
import japan1 from "../../assets/places/japan/japan1.jpg";
import japan2 from "../../assets/places/japan/japan2.jpg";
import japan3 from "../../assets/places/japan/japan3.jpg";
import japanBackground from "../../assets/places/japan/japan4.jpg";
import brazil1 from "../../assets/places/brazil/brazil.jpg";
import brazil2 from "../../assets/places/brazil/brazil1.jpg";
import brazil3 from "../../assets/places/brazil/brazil2.jpg";
import brazilBackground from "../../assets/places/brazil/brazil3.jpg";

const packageData = [
  {
    id: 1,
    title: "Romantic Dubai Retreat With FREE Parks & Resorts Tickets",
    duration: "7 days & 6 nights",
    price: "INR 86,000",
    originalPrice: "INR 1,00,225",
    discount: "Save INR 14,225",
    specialDiscount: "20",
    rating: 4.6,
    reviews: 170,
    images: [dubai, dubai10, dubai12],
  },
  {
    id: 2,
    title: "Dubai Delights | Crossroad Cultures Of The Middle East",
    duration: "6 days & 5 nights",
    price: "INR 67,074",
    originalPrice: "INR 89,000",
    discount: "Save INR 21,926",
    specialDiscount: "20",
    rating: 5.0,
    reviews: 100,
    images: [dubai2, dubai3, dubai4],
  },
  {
    id: 3,
    title: "Getaway To Dubai | Sands, Skyscrapers And Sea",
    duration: "5 days & 4 nights",
    price: "INR 45,000",
    originalPrice: "INR 56,322",
    discount: "Save INR 11,322",
    specialDiscount: "20",
    rating: 4.9,
    reviews: 1500,
    images: [dubai5, dubai6, dubai7],
  },
  {
    id: 1,
    title: "Bali Bliss | Tropical Paradise",
    duration: "5 days & 4 nights",
    price: "INR 52,750",
    originalPrice: "INR 1,00,225",
    discount: "Save INR 47,475",
    specialDiscount: "20",
    rating: 4.6,
    reviews: 170,
    images: [bali, bali1, bali2],
  },
  {
    id: 4,
    title: "Singapore Extravaganza | Urban Wonders",
    duration: "4 days & 3 nights",
    price: "INR 36,500",
    originalPrice: "INR 96,000",
    discount: "Save INR 59,599",
    specialDiscount: "20",
    rating: 4.6,
    reviews: 170,
    images: [singapur, singapur1, singapur2],
  },
  {
    id: 6,
    title: "Singapore Family Fun | Universal Studios and Sentosa",
    duration: "6 days & 5 nights",
    price: "INR 70,000",
    originalPrice: "INR 95,000",
    discount: "Save INR 25,000",
    specialDiscount: "20",
    rating: 4.9,
    reviews: 300,
    images: [singapur3, singapur4, singapur5],
  },
  {
    id: 7,
    title: "Discover Japan | Temples and Modernity",
    duration: "7 days & 6 nights",
    price: "INR 1,20,000",
    originalPrice: "INR 1,50,000",
    discount: "Save INR 30,000",
    specialDiscount: "20",
    rating: 4.8,
    reviews: 300,
    images: [japan1, japan2, japan2],
  },
  {
    id: 8,
    title: "Malaysia Explorer | City and Islands",
    duration: "5 days & 4 nights",
    price: "INR 32,990",
    originalPrice: "INR 70,000",
    discount: "Save INR 37,010",
    specialDiscount: "20",
    rating: 4.4,
    reviews: 150,
    images: [malaysia, malaysia1, malaysia2],
  },
  {
    id: 9,
    title: "Malaysia Explorer (With flight)",
    duration: "6 days & 5 nights",
    price: "INR 52,000",
    originalPrice: "INR 60,000",
    discount: "Save INR 8,000",
    specialDiscount: "20",
    rating: 4.8,
    reviews: 150,
    images: [malaysia3, malaysia4, malaysia5],
  },
  {
    id: 1,
    title: "Brazil Nature & Culture Tour",
    duration: "10 days & 9 nights",
    price: "INR 1,90,000",
    originalPrice: "INR 2,50,000",
    discount: "Save INR 60,000",
    specialDiscount: "20",
    rating: 4.9,
    reviews: 180,
    images: [brazil1, brazil2, brazil3], // Replace with actual image variable
  },
];

const BlogsComp = () => {
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const theme = useSelector((state) => state.theme.theme); // Assuming 'theme' holds 'dark' or 'light'
  const isDarkTheme = theme === "dark";
  const themeClasses = isDarkTheme
    ? "bg-black text-white"
    : "bg-white text-black";

  return (
    <div className={`${themeClasses} py-10`}>
      <section data-aos="fade-up" className=" ">
        <h1 className="my-8 border-l-8 text-[#5b53fb] flex justify-center border-[#5b53fb] py-2 pl-2 md:text-4xl text-3xl font-bold relative">
          <span className="z-10 bg-clip-text flex justify-start md:justify-center text-transparent bg-[#5b53fb]">
            Our Latest Packages
          </span>
          {/* <div className="absolute inset-0 bg-gradient-to-r from-teal-200 to-transparent blur-lg opacity-70"></div> */}
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {packageData.map((item) => (
            <SuggestionCardForBestPlaces key={item.id} packageData={item} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default BlogsComp;
